var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('modal-cart'),_c('modal-finding'),_c('modal-order-successful'),_c('app-mobile-drawer'),_c('app-header'),_c('main',{staticClass:"main"},[_vm._t("default")],2),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }